import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useLang } from "@/context";
import { Reveal } from "@/components/Reveal";

export default function PrivacyPage() {
  const { t } = useLang();

  return (
    <div data-testid="privacy-page" className="bg-ivory min-h-screen">
      <Nav />
      <div className="pt-32 sm:pt-40 pb-28 max-w-3xl mx-auto px-6 sm:px-12">
        <Reveal className="flex items-center gap-4 mb-10">
          <span className="gold-rule w-14" aria-hidden="true" />
          <span className="text-[11px] uppercase tracking-[0.34em] text-gold">{t.legal.label}</span>
        </Reveal>
        <Reveal>
          <h1 data-testid="privacy-title" className="font-serif text-4xl sm:text-5xl text-charcoal font-medium leading-[1.1]">
            {t.legal.title}
          </h1>
        </Reveal>
        {t.legal.updated && (
          <Reveal delay={0.05}>
            <p data-testid="privacy-updated" className="mt-4 text-[11px] uppercase tracking-[0.22em] text-taupe">
              {t.legal.updated}
            </p>
          </Reveal>
        )}
        {t.legal.intro && (
          <Reveal delay={0.1}>
            <p className="mt-7 text-sm sm:text-base text-ink/70 leading-relaxed font-light">{t.legal.intro}</p>
          </Reveal>
        )}
        <div className="mt-12">
          {t.legal.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.03} y={16}>
              <div data-testid={`privacy-section-${i}`} className="border-t border-taupe/25 py-7">
                <h2 className="font-serif text-xl sm:text-2xl text-charcoal font-medium">{s.h}</h2>
                <p className="mt-3 text-sm sm:text-base text-ink/70 leading-relaxed font-light">{s.p}</p>
                {s.items && (
                  <div className="mt-4 space-y-2.5">
                    {s.items.map((item) => (
                      <div key={item} className="flex items-baseline gap-3">
                        <span className="w-1 h-1 bg-gold rotate-45 shrink-0 translate-y-[-2px]" aria-hidden="true" />
                        <span className="text-sm sm:text-base text-ink/70 leading-relaxed font-light">{item}</span>
                      </div>
                    ))}
                  </div>
                )}
                {s.p2 && (
                  <p className="mt-4 text-sm sm:text-base text-ink/70 leading-relaxed font-light">{s.p2}</p>
                )}
              </div>
            </Reveal>
          ))}
          <div className="border-t border-taupe/25" />
        </div>
      </div>
      <Footer />
    </div>
  );
}
